import React, { memo, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Button from '@material-ui/core/Button';
import { isMobile, isTablet } from "react-device-detect";
import { useRecoilState } from 'recoil';

import { IAsset, assetTabListState, assetTabIndexState, assetListRefreshState } from '../../store/AssetsStore';
import { useSpinner } from '../../../../../../core/contexts/SpinnerContext';
import { unlinkSensor } from "../../../../../Common/Apis/VehicleApi";
import { useNotification } from "../../../../../../core/contexts/NotificationContext";

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: (arg0: number) => void;
  items: IAsset[];
  paging: any;
  linkSensorClicked: (arg0: IAsset) => void;
}

const AssetListItem = ({ pageSizeChanged, pageNoChanged, items, paging, linkSensorClicked }: IProps) => {

  const [tabList, setTabList] = useRecoilState(assetTabListState);
  const [, setTabIndex] = useRecoilState(assetTabIndexState);
  const [refreshStatus, setRefreshStatus] = useRecoilState(assetListRefreshState);

  const { showSuccess } = useNotification();
  const { setSpinner } = useSpinner();

  const onPage = (e: any) => {

    const { page, rows } = e;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };

  const addAssetTab = (item: IAsset) => {

    const thisIndex = tabList.findIndex((i) => {
      if (i.VehicleId === item.VehicleId)
        return true;

      return false;
    });

    //if (searchTab.length == 0) {
    if (thisIndex < 0) {
      setTabList([...tabList, item]);
    }
    else {
      setTabIndex(thisIndex + 2);
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);

    const datatableList = document.getElementsByClassName("p-datatable-scrollable-body");
    if (datatableList.length > 0) {
      datatableList[0].scrollTop = 0;
    }

  }, [items]);

  const setDetail = (row: IAsset, val: any) => {
    return (
      <span className="info-sub-head cursor-pointer" onClick={() => addAssetTab(row)} >
        <strong className="opt-l-number">
          {val}
        </strong>
      </span>
    );
  };

  const unlinkSensorClicked = async (row: IAsset) => {
    if (window.confirm("Are you sure you want to unlink the sensor?")) {

      try {

        setSpinner(true);
        await unlinkSensor(row.VehicleId);
        setRefreshStatus(!refreshStatus);
        showSuccess("success", "sucessfully saved", "", 3000, null);
      }
      catch (err) {
        console.log('err', err);
      }

      setSpinner(false);
    }


  };


  const setSensor = (row: IAsset) => {
    if (row.SensorId !== "") {
      return (
        <span >
          <Button
            type='button'
            onClick={() => unlinkSensorClicked(row)}
            variant={isMobile ? "outlined" : "text"} color="primary" style={{ textTransform: 'none' }} >Unlink</Button>
        </span>
      );
    }
    else {
      return (
        <span >
          <Button
            onClick={() => linkSensorClicked(row)}
            variant={isMobile ? "outlined" : "text"} color="primary" style={{ textTransform: 'none' }} >Link</Button>
        </span >
      );
    }
  };

  const setNormalDataTable = () => {
    return (
      <DataTable
        rowHover
        style={{ position: "relative" }}

        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable scrollHeight="calc(100vh - 390px)"

      >
        <Column field="VehiclePlate" header="Vehicle Plate" body={(r: IAsset) => setDetail(r, r.VehiclePlate)} />
        <Column field="VehicleCode" header="Vehicle Code" body={(r: IAsset) => setDetail(r, r.VehicleCode)} />
        <Column field="FleetName" header="Fleet Name" />
        <Column field="RucMonkeyVehicleTypeName" header="Vehicle Type" />
        <Column field="SensorId" header="Sensor Id" />
        <Column field="SensorSerialNumber" header="Serial Number" />
        <Column field="SensorSerialNumber" header="Sensor" body={(r: IAsset) => setSensor(r)} />
      </DataTable>
    );
  };

  const setResponsiveContents = (title: string, contents: any, isTitle = true) => {
    return (
      <>
        {isTitle && <span className="p-column-title">{title}</span>}
        <span className="p-column-content">{contents}</span>
      </>
    );
  };

  const setResponsiveDataTable = () => {
    return (
      <DataTable
        header='Vehicles'
        style={{ position: "relative" }}
        value={items}
        className="p-datatable-responsive p-datatable-sm "
        paginator
        paginatorTemplate="CurrentPageReport  PageLinks  RowsPerPageDropdown"
        currentPageReportTemplate=" {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
      >
        <Column header="Vehicle Plate" body={(r: IAsset) => setResponsiveContents('Vehicle Plate', setDetail(r, r.VehiclePlate))} />
        <Column header="Vehicle Code" body={(r: IAsset) => setResponsiveContents('Vehicle Plate', setDetail(r, r.VehicleCode))} />
        <Column header="Vehicle Code" body={(r: IAsset) => setResponsiveContents('Fleet Name', r.FleetName)} />
        <Column header="Vehicle Type" body={(r: IAsset) => setResponsiveContents('Vehicle Type', r.RucMonkeyVehicleTypeName)} />
        <Column header="Sensor Id" body={(r: IAsset) => setResponsiveContents('Sensor Id', r.SensorId)} />
        <Column header="Serial Number" body={(r: IAsset) => setResponsiveContents('Serial Number', r.SensorSerialNumber)} />
        <Column header="Serial Number" body={(r: IAsset) => setResponsiveContents('Set Sensor', setSensor(r))} />
      </DataTable>
    );
  };


  const setDataTable = () => {
    if (isMobile && !isTablet) {
      return setResponsiveDataTable();
    }
    else {
      return setNormalDataTable();
    }
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setDataTable()}
      </div>

    </>
  );

};

export default memo(AssetListItem);